import temperatureChart from './temperature-chart'
import humidityChart from './humidity-chart'
import lightChart from './light-chart'

class ReadingCharts {

  constructor (container) {
    this.container = container;
    this.charts = [];

    this.init();
  }

  init() {
    const chartTypes = [
      {
        name: "Probe Temperature",
        datapoint: "tcTemp",
        type: "temperature",
      },
      {
        name: "Probe Temperature",
        datapoint: "tcTemp2",
        type: "temperature",
      },
      {
        name: "Light",
        datapoint: "light",
        type: "light",
      },
      {
        name: "Temperature",
        datapoint: "temperature",
        type: "temperature",
      },
      {
        name: "Humidity",
        datapoint: "humidity",
        type: "humidity",
      },
    ];

    chartTypes.forEach(type => {
      const chartDiv = document.createElement('div');
      chartDiv.className = 'dashboard-lite__chart';
      chartDiv.setAttribute('data-for', type.datapoint);

      const chartHeading = document.createElement('div');
      chartHeading.className = 'dashboard-lite__chart-heading dashboard-lite__chart-heading--' + type.datapoint;

      const chartHeadingContainer = document.createElement('div');
      chartHeadingContainer.className = 'dashboard-lite__chart-heading__container';

      const chartHeadingContent = document.createElement('div');
      chartHeadingContent.className = 'dashboard-lite__chart-heading__heading';

      const icon = document.createElement('i');
      icon.className = 'fas fa-thermometer-three-quarters';

      if(type.type === 'humidity') {
        icon.className = 'fas fa-tint';
      } else if(type.type === 'light') {
        icon.className = 'fas fa-lightbulb-on';
      }

      chartHeadingContent.appendChild(icon);
      chartHeadingContent.appendChild(document.createTextNode(' ' + type.name));

      const downloadDiv = document.createElement('div');
      downloadDiv.className = 'dashboard-lite__chart-heading__download';

      const button = document.createElement('button');
      button.className = 'dashboard-lite__download-sensor-readings button button--light-gray button--tiny';
      button.setAttribute('disabled', true);

      const buttonIcon = document.createElement('i');
      buttonIcon.className = 'fas fa-cloud-download';

      button.appendChild(buttonIcon);
      button.appendChild(document.createTextNode(' Download (CSV)'));

      downloadDiv.appendChild(button);

      const dateRangeSpan = document.createElement('span');
      dateRangeSpan.className = 'dashboard-lite__chart-heading__download-date-range';

      downloadDiv.appendChild(dateRangeSpan);

      chartHeadingContainer.appendChild(chartHeadingContent);
      chartHeadingContainer.appendChild(downloadDiv);

      chartHeading.appendChild(chartHeadingContainer);

      const canvas = document.createElement('canvas');
      canvas.className = type.datapoint + '-chart';

      const noReadingsDiv = document.createElement('div');
      noReadingsDiv.className = 'dashboard-lite__chart__no-readings';
      noReadingsDiv.textContent = 'No readings found for this date range';

      chartDiv.appendChild(chartHeading);
      chartDiv.appendChild(canvas);
      chartDiv.appendChild(noReadingsDiv);

      this.container.appendChild(chartDiv);

      let chart = null;

      switch (type.type) {
        case("temperature"):
          chart = new temperatureChart(canvas, {
            source: type.datapoint,
          });
          break;
        case("humidity"):
          chart = new humidityChart(canvas, {
            source: type.datapoint,
          });
        case("light"):
          chart = new lightChart(canvas, {
            source: type.datapoint,
          });
          break;
      }
      this.charts.push({
        name: type.name,
        type: type.type,
        datapoint: type.datapoint,
        container: chartDiv,
        chart,
        chartCanvas: canvas,
        noReadingsContainer: noReadingsDiv,
      });

    });

  }

  render(sensor) {

    if(sensor.last_temp == 0 && sensor.last_humidity == 0 && sensor.last_voltage == 0) {
      $(".dashboard").find(".dashboard-lite__charts").hide();
      $(".dashboard").find(".dashboard-lite__charts-offline-message").hide();
      return;
    }

    $(".dashboard").find(".dashboard-lite__charts").show();
    $(".dashboard").find(".dashboard-lite__charts-offline-message").show();

    let activeCharts = [];

    switch(sensor.type) {
      case("EX"):

        if(sensor.TC_M && sensor.TC_M == 1) {
          activeCharts = ["tcTemp", "temperature", "humidity"];
        } else {
          activeCharts = ["temperature", "humidity", "tcTemp"];
        }

        break;
      default:
        activeCharts = ["temperature", "humidity"];
        break;
    }

    if(sensor.version >= 3000) {
      activeCharts = ["tcTemp", "tcTemp2", "light", "temperature", "humidity"];

      $("body").find('.dashboard-lite__chart-heading--tcTemp .dashboard-lite__chart-heading__heading').html(`
      <div class="dashboard-lite__chart-heading__heading"><img src="${window.site.home}/../assets/images/icon-tc-probe-red.svg" width="12" height="12"> Probe (1)</div>
      `)

      $("body").find('.dashboard-lite__chart-heading--tcTemp2 .dashboard-lite__chart-heading__heading').html(`
      <div class="dashboard-lite__chart-heading__heading"><img src="${window.site.home}/../assets/images/icon-tc-probe-red.svg" width="12" height="12"> Probe (2)</div>
      `)

    } else {
      $("body").find('.dashboard-lite__chart-heading--tcTemp .dashboard-lite__chart-heading__heading').html(`
      <div class="dashboard-lite__chart-heading__heading"><img src="${window.site.home}/../assets/images/icon-tc-probe-red.svg" width="12" height="12"> Probe Temperature</div>
      `)
    }

    const nodes = Array.from(this.container.childNodes);

    nodes.forEach(node => {
      const dataFor = node.getAttribute('data-for');

      if (activeCharts.includes(dataFor)) {
        node.classList.add('is-active');
      } else {
        node.classList.remove('is-active');
      }
    });

    nodes.sort((a, b) => {
      const aDataFor = a.getAttribute('data-for');
      const bDataFor = b.getAttribute('data-for');

      const aIndex = activeCharts.indexOf(aDataFor);
      const bIndex = activeCharts.indexOf(bDataFor);

      if (aIndex === -1 && bIndex === -1) {
        return 0;
      } else if (aIndex === -1) {
        return 1;
      } else if (bIndex === -1) {
        return -1;
      } else {
        return aIndex - bIndex;
      }
    });

    nodes.forEach(node => {
      this.container.appendChild(node);
    });

  }

}

export default ReadingCharts;
